/**
 *
 * SubText
 *
 */
import styled from 'styled-components';

const SubText = styled.p`
  padding: 0 20px;
  max-width: 650px;
  margin: auto;
  margin-bottom: 40px;
  font-size: 18px;
  text-align: center;

  @media screen and (min-width: 600px) {
    font-size: 24px;
  }
`;

export default SubText;
